import { Pages } from '@app/App';
import { MAYA_FONTS } from '@root/Theme';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
    ContentContainer,
    FooterText,
    MainContainer,
    StyledButton,
    StyledTypography,
} from './ProjectOverview.s';

const ProjectOverview: React.FC = () => {
    const navigate = useNavigate();

    const handleAdminRedirect = () => {
        navigate(Pages.ADMIN);
    };

    return (
        <MainContainer>
            <ContentContainer>
                <img
                    src="/maya_logo.png"
                    alt="MAYA"
                    style={{
                        height: 'clamp(140px, 26vh, 280px)',
                        width: 'auto',
                        display: 'block',
                        marginBottom: '24px',
                    }}
                />
                <StyledTypography
                    variant="h2"
                    gutterBottom
                    fontFamily={MAYA_FONTS.display}
                    fontWeight={500}
                    sx={{
                        fontSize: { xs: '2.2rem', sm: '3rem', md: '3.75rem' },
                        lineHeight: 1.15,
                        letterSpacing: '-0.02em',
                    }}
                >
                    MAYA Project
                </StyledTypography>
                <StyledTypography
                    variant="h5"
                    fontWeight={600}
                    sx={{
                        maxWidth: '700px',
                        textAlign: 'center',
                        marginBottom: 2,
                        fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' },
                        lineHeight: 1.3,
                        letterSpacing: '-0.01em',
                        color: 'text.secondary',
                    }}
                >
                    Experimental Platform for AI-Generated Visual Content
                </StyledTypography>
                <StyledTypography
                    variant="body1"
                    fontWeight={400}
                    sx={{
                        maxWidth: '800px',
                        textAlign: 'center',
                        marginBottom: 4,
                        fontSize: { xs: '1.1rem', sm: '1.25rem', md: '1.4rem' },
                        lineHeight: 1.75,
                        letterSpacing: '0.003em',
                    }}
                >
                    MAYA is an experimental platform designed for research purposes. The MAYA module for
                    AI-generated visual content provides a viable research environment for the study and
                    experimental exploration of text-image interactions between users and AI agents.
                </StyledTypography>
                <StyledButton variant="contained" onClick={handleAdminRedirect}>
                    Admin Page
                </StyledButton>
            </ContentContainer>
            <FooterText variant="body2">
                © {new Date().getFullYear()} MAYA Project. All Rights Reserved.
            </FooterText>
        </MainContainer>
    );
};

export default ProjectOverview;
